import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DatePickerInput(props) {
  return (
    <div className="flex w-full">
      <DatePicker {...props}></DatePicker>
    </div>
  );
}

export default DatePickerInput;
